import {emotionStyled, tokens} from '@packages/utilities/styled';
import {Icon} from '../../icons/Icon';
import {Composite} from '@floating-ui/react';

export const SegmentedControlView = emotionStyled(Composite)(
  {
    position: 'relative',
    flexBasis: '100%',
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: '1fr',
    gridColumnGap: '1px',
    background: '$actionSecondaryBackground',
    boxShadow: '$actionSecondary',
    borderRadius: '3px',
    padding: '1px',
    width: 'fit-content',
    'button[data-focus="true"], button:focus-visible': {
      outlineWidth: '1px !important',
      outlineStyle: 'solid !important',
      outlineOffset: '1px !important',
      outlineColor: '$blueBorder !important',
    },
    '& > *': {
      [Icon.__experimentalTokens.color]: tokens.colors.textSecondary,
      background: 'transparent !important',
      boxShadow: 'none !important',
      color: '$textSecondary !important',
      height: tokens.ui.segmentedControl.height,
      borderRadius: '3px !important',
      borderColor: 'transparent !important',
      marginInlineStart: '0px !important',
    },
    'button:hover:not([disabled], [aria-disabled="true"]):not([aria-checked="true"])':
      {
        [Icon.__experimentalTokens.color]: tokens.colors.actionSecondaryText,
        background: '$uiBackgroundHover !important',
        color: '$actionSecondaryText !important',
        [`& ${Icon}`]: {
          color: '$actionSecondaryText !important',
        },
      },
    '[aria-checked="true"]': {
      [Icon.__experimentalTokens.color]: tokens.colors.actionSecondaryText,
      backgroundColor: '$uiSegmentedControlActive !important',
      boxShadow: tokens.boxShadows.segmentedControl,
      borderRadius: '3px !important',
      color: '$actionSecondaryText !important',
    },
  },
  {
    componentName: 'SegmentedControl',
    variants: {
      isFullWidth: {
        true: {
          width: '100%',
        },
      },
    },
    /**
     * We need to remove isFullWidth from the props we pass through to `Composite`.
     *
     * As passing them through will cause a DOM error.
     */
    filterForwardedProps: ({isFullWidth: _, ...rest}) => rest,
  }
);
